<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("phoneVerification") }}</h1>
                <phone-verification-form/>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import PhoneVerificationForm from '@investor/components/registration/PhoneVerificationForm';
    import ProfileHeader from '@investor/components/profile/ProfileHeader';

    export default {
        components: {
            ProfileHeader,
            PhoneVerificationForm,
        }
    }
</script>


